<div #contentToPrint>
  <div class="container" data-aos="fade-down-left" id="print-section" data-aos-duration="2500"
    [ngStyle]="!isDarkTheme ?{'color':'#000000'} : {'color': '#ffffff'}">
    
    <div class="analytics">
      <i style="align-self: flex-end" class="bi bi-printer-fill" (click)="saveAsPDF()"></i>
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;">
       <label class="chi-label -xl" style="font-size: 2em;">Black Lotus Labs</label>
        <div class="chi-dropdown" style="margin-left: auto;">
          <button id="dropdown-1" style="width: 180px;"
            class="chi-button chi-dropdown__trigger -d--flex -justify-content--between">
            {{ dropdownLabel }}
          </button>
          <div class="chi-dropdown__menu">
            <a class="chi-dropdown__menu-item" (click)="change_time_period('last 24 hours', 'Last 24 hrs'); $event.preventDefault()">Last 24 hrs</a>
            <a class="chi-dropdown__menu-item" (click)="change_time_period('last 7 days', 'Last 7 days'); $event.preventDefault()">Last 7 days</a>
            <a class="chi-dropdown__menu-item" (click)="change_time_period('last 30 days', 'Last 30 days'); $event.preventDefault()">Last 30 days</a>
          </div>
        </div>
      </div>
      

      <div class="chi-accordion section-card" [ngClass]="{'dark-mode': isDarkTheme}">
        <div
          class="chi-accordion__item"
          *ngFor="let item of accordions; let i = index"
          [class.-expanded]="item.expanded"
          [ngClass]="{'dark-mode': isDarkTheme}"
        >
          <button class="chi-accordion__trigger" (click)="toggleAccordion(i)">
            <div class="chi-accordion__title" [ngClass]="{'dark-mode': isDarkTheme}">{{ item.title }}</div>
            <i class="chi-icon icon-chevron-down" aria-hidden="true"></i>
          </button>
          <div class="chi-accordion__content">
            <p class="chi-accordion__text">{{ item.text }}</p>
          </div>
        </div>
      </div>
      
      <div class="section-card" [ngClass]="{'dark-mode': isDarkTheme}">
        <div class="overview">
          <div class="left">
            <label class="chi-label">Total Threats</label>
                <div class="overview-totals-row" style="display: flex; justify-content: left; align-items: center; gap: 50px;">
                  <span class="overview_total">
                    Total Threat IPs Recorded
                    <span class="overview_total_number">{{ total_threats | number }}</span>
                  </span>
                  <span class="overview_total">
                    Total Records Scanned
                    <span class="overview_total_number">{{ total_records | number }}</span>
                  </span>
                </div>
          </div>
        </div>
      </div>

      <div class="section-card" [ngClass]="{'dark-mode': isDarkTheme}">
        <label class="chi-label">Top Five Threats</label>
        @if (!minimizeMetrics) {
          <app-top-metrics [top_threat_data]="top_five_ips"></app-top-metrics>
        }
      </div>

      <div class="section-card" [ngClass]="{'dark-mode': isDarkTheme}">
        <div class="chart-container">
          <div class="chart-heading">Overall threats Seen</div>
          <div class="icon-container">
            <i [class]="'bi ' +(minimizeChart ? 'bi-arrows-angle-expand' : 'bi-dash-circle')" (click)="minimizedChart()"></i>
            <i [class]="'bi ' +(minimizeBar ? 'bi-arrows-angle-expand' : 'bi-dash-circle')" (click)="minimizedBar()"></i>
          </div>
          @if (dataLoaded) {
            <div class="stats">
              @if (!minimizeChart) {
                <div class="pie-container">
                  <app-donut-chart [total_threat_data]="total_threat_list"></app-donut-chart>
                </div>
              }
              @if (!minimizeBar) {
                <div class="bar-container">
                  <app-bar-chart [bar_threat_data]="top_ten_ips"></app-bar-chart>
                </div>
              }
            </div>
          }
        </div>
      </div>

      <div class="section-card" [ngClass]="{'dark-mode': isDarkTheme}">
        <app-industry-insights [timeline]="timeline" [isDarkTheme]="isDarkTheme" [naics_dict]="naics_dict"></app-industry-insights>
      </div>

      <div class="section-card" [ngClass]="{'dark-mode': isDarkTheme}">
        <app-industry-sector-drilldown
          [naics_dict]="naics_dict"
          [isDarkTheme]="isDarkTheme">
        </app-industry-sector-drilldown>
      </div>

      <div class="section-card" [ngClass]="{'dark-mode': isDarkTheme}">
        @if (show_threat_map) {
          <div class="map-container">
            <div class="map-heading">Cyber-security Threats
              <i style="float: right" [class]="'bi ' +(minimizeMap ? 'bi-arrows-angle-expand' : 'bi-dash-circle')"
              (click)="minimizedMap()"></i>
            </div>
            @if (!minimizeMap) {
              <app-map-with-animation [threat_map_list]="threat_map_list"></app-map-with-animation>
            }
          </div>
        }
      </div>
    </div>
  </div>

</div>


